import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

const NO_AUTH_PATHS = ['/Admin/Login']

const request = axios.create({
  baseURL: '',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
})

request.interceptors.request.use(config => {
  const url = config.url || ''
  const skipAuth = NO_AUTH_PATHS.some(p => url.indexOf(p) !== -1)
  if (!skipAuth) {
    const token = store.state.auth.token
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  // FormData 须由浏览器自动带 boundary，不能沿用 application/json
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  return config
})

request.interceptors.response.use(
  response => {
    const res = response.data
    if (!res || typeof res.code === 'undefined') return res
    if (Number(res.code) === 200) return res
    const msg = res.msg || '请求失败'
    if (Number(res.code) === 401) {
      store.commit('auth/CLEAR_AUTH')
      if (router.currentRoute.name !== 'Login') {
        router.push({ name: 'Login' })
      }
    }
    Message.error(msg)
    return Promise.reject(res)
  },
  error => {
    const server = error.response && error.response.data
    Message.error((server && server.msg) || error.message || '网络错误')
    return Promise.reject(error)
  }
)

export function post(url, data, config) {
  return request.post(url, data, config)
}

export default request
